export default __webpack_public_path__ + "static/media/IsotipoIDP.af5fb54c.svg";